
(function () {
  'use strict';

  const STORAGE_KEY = 'bubble_verified_pincode';
  const SELECTORS = {
    checker: '[data-pincode-checker]',
    input: '.custom-pincode-input',
    checkButton: '.custom-pincode-check',
    message: '.custom-pincode-message',
    addToCart: '#AddToCart',
    stickyAddToCart: '#AddToCartSticky',
    paymentButton: '.shopify-payment-button',
    productForm: 'product-form[data-section] form[data-type="add-to-cart-form"]',
    variantSelects: 'variant-selects'
  };

  let pincodeVerified = false;
  let verifiedPincode = null;

  function getElements() {
    const checker = document.querySelector(SELECTORS.checker);
    return {
      checker,
      input: checker ? checker.querySelector(SELECTORS.input) : null,
      checkButton: checker ? checker.querySelector(SELECTORS.checkButton) : null,
      message: checker ? checker.querySelector(SELECTORS.message) : null,
      addToCart: document.querySelector(SELECTORS.addToCart),
      stickyAddToCart: document.querySelector(SELECTORS.stickyAddToCart),
      paymentButton: document.querySelector(SELECTORS.paymentButton),
      productForm: document.querySelector(SELECTORS.productForm)
    };
  }

  function isValidPincode(pincode) {
    return /^[1-9][0-9]{5}$/.test(String(pincode).trim());
  }

  function isJammuKashmirPincode(pincode) {
    const pin = String(pincode).trim();
    return /^(18|19)\d{4}$/.test(pin) && !/^194\d{3}$/.test(pin);
  }

  function isServiceable(pincode) {
    return isValidPincode(pincode) && !isJammuKashmirPincode(pincode);
  }

  function setMessage(message, type) {
    const element = getElements().message;
    if (!element) return;
    element.textContent = message;
    element.className = 'custom-pincode-message';
    if (type) element.classList.add(type);
  }

  function clearMessage() {
    const element = getElements().message;
    if (!element) return;
    element.textContent = '';
    element.className = 'custom-pincode-message';
  }

  function savePincode(pincode) {
    try {
      localStorage.setItem(STORAGE_KEY, pincode);
    } catch (error) {}
  }

  function getSavedPincode() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function removeSavedPincode() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function isProductAvailable(button) {
    return button && !button.classList.contains('sold-out');
  }

  function updateAddToCartState() {
    const elements = getElements();

    if (elements.addToCart) {
      elements.addToCart.disabled =
        !pincodeVerified || !isProductAvailable(elements.addToCart);
    }

    if (elements.stickyAddToCart) {
      elements.stickyAddToCart.disabled =
        !pincodeVerified || !isProductAvailable(elements.stickyAddToCart);
    }
  }

  function updateBuyNowState() {
    const button = getElements().paymentButton;
    if (!button) return;

    button.classList.toggle('pincode-disabled', !pincodeVerified);
    button.setAttribute('aria-disabled', String(!pincodeVerified));
  }

  function updateStickyPincodeHint() {
    const hint = document.querySelector('.sticky-pincode-hint');
    if (hint) hint.classList.toggle('is-hidden', pincodeVerified);
  }

  function updatePurchaseButtons() {
    updateAddToCartState();
    updateBuyNowState();
    updateStickyPincodeHint();
  }

  function resetPincodeVerification(clearInput) {
    pincodeVerified = false;
    verifiedPincode = null;
    removeSavedPincode();

    const elements = getElements();
    if (clearInput && elements.input) elements.input.value = '';

    clearMessage();
    updatePurchaseButtons();
  }

  function checkPincode() {
    const elements = getElements();
    if (!elements.input) return;

    const pincode = elements.input.value.trim();
    pincodeVerified = false;
    verifiedPincode = null;
    updatePurchaseButtons();

    if (!pincode) {
      setMessage('Please enter your pincode.', 'error');
      return;
    }

    if (!isValidPincode(pincode)) {
      setMessage('Please enter a valid 6-digit pincode.', 'error');
      return;
    }

    if (elements.checkButton) {
      elements.checkButton.disabled = true;
      elements.checkButton.textContent = 'CHECKING...';
    }

    setMessage('Checking delivery availability...', 'loading');

    window.setTimeout(function () {
      if (isJammuKashmirPincode(pincode)) {
        resetPincodeVerification(false);
        setMessage('Delivery is not available in Jammu & Kashmir.', 'error');
      } else if (isServiceable(pincode)) {
        pincodeVerified = true;
        verifiedPincode = pincode;
        savePincode(pincode);
        setMessage('✓ Delivery available at ' + pincode, 'success');
      } else {
        resetPincodeVerification(false);
        setMessage('Please enter a valid 6-digit pincode.', 'error');
      }

      updatePurchaseButtons();

      if (elements.checkButton) {
        elements.checkButton.disabled = false;
        elements.checkButton.textContent = 'CHECK';
      }
    }, 300);
  }

  function setupInput(input) {
    if (!input || input.dataset.pincodeBound === 'true') return;
    input.dataset.pincodeBound = 'true';

    input.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 6);

      if (this.value !== verifiedPincode) {
        pincodeVerified = false;
        verifiedPincode = null;
        removeSavedPincode();
        updatePurchaseButtons();
      }

      clearMessage();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkPincode();
      }
    });
  }

  function setupCheckButton(button) {
    if (!button || button.dataset.pincodeBound === 'true') return;
    button.dataset.pincodeBound = 'true';

    button.addEventListener('click', function (event) {
      event.preventDefault();
      checkPincode();
    });
  }

  function setupProductFormProtection(form) {
    if (!form || form.dataset.pincodeBound === 'true') return;
    form.dataset.pincodeBound = 'true';

    form.addEventListener('submit', function (event) {
      if (pincodeVerified && !isJammuKashmirPincode(verifiedPincode)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setMessage('Please check your pincode before adding this product to cart.', 'error');

      const input = getElements().input;
      if (input) input.focus();

      updatePurchaseButtons();
    }, true);
  }

  function setupBuyNowProtection(button) {
    if (!button || button.dataset.pincodeBound === 'true') return;
    button.dataset.pincodeBound = 'true';

    button.addEventListener('click', function (event) {
      if (pincodeVerified && !isJammuKashmirPincode(verifiedPincode)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      setMessage('Please check your pincode before buying this product.', 'error');

      const input = getElements().input;
      if (input) input.focus();

      updatePurchaseButtons();
    }, true);
  }

  function setupVariantListener() {
    document.querySelectorAll(SELECTORS.variantSelects).forEach(function (element) {
      if (element.dataset.pincodeBound === 'true') return;
      element.dataset.pincodeBound = 'true';

      element.addEventListener('change', function () {
        window.setTimeout(updatePurchaseButtons, 150);
        window.setTimeout(updatePurchaseButtons, 500);
      });
    });
  }

  function observeAddToCartButton() {
    const button = getElements().addToCart;
    if (!button || button.dataset.pincodeObserved === 'true') return;
    button.dataset.pincodeObserved = 'true';

    new MutationObserver(function () {
      updateAddToCartState();
    }).observe(button, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function restoreSavedPincode() {
    const elements = getElements();
    if (!elements.input) return;

    const saved = getSavedPincode();
    if (!saved || !isServiceable(saved)) {
      removeSavedPincode();
      return;
    }

    elements.input.value = saved;
    pincodeVerified = true;
    verifiedPincode = saved;
    setMessage('✓ Delivery available at ' + saved, 'success');
  }

  function initializePincodeValidator() {
    const elements = getElements();
    if (!elements.checker) return;

    setupInput(elements.input);
    setupCheckButton(elements.checkButton);
    setupProductFormProtection(elements.productForm);
    setupBuyNowProtection(elements.paymentButton);
    setupVariantListener();
    observeAddToCartButton();
    restoreSavedPincode();
    updatePurchaseButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePincodeValidator);
  } else {
    initializePincodeValidator();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initializePincodeValidator, 100);
  });
})();
